/* Native trial acceptance. No Admin credential, code creation or selling plan. */
(function (host, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else host.antiTrialOffer = api.create({ fetch: host.fetch.bind(host), root: (host.Shopify && host.Shopify.routes.root) || '/', cartState: function () { return host.antiCartState; }, storage: host.sessionStorage, shippingClaimed: function () { return host.localStorage.getItem('antiFreeShipClaimed') === 'true' && host.sessionStorage.getItem('antiFreeShipSession') === 'true'; }, uuid: function () { return host.crypto.randomUUID(); } });
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var SHIPPING_CODE = 'BUNDLE-SHIP';
  // A persisted attempt blocks a second Add while an earlier Add could still land (its
  // request gives up after 10 s). Two minutes on, an attempt whose bag never appeared
  // is dead: without this it blocked the offer for the rest of the tab (2026-10-27).
  var RECOVERY_MS = 120000;
  // wp_trial_20_v1: version B of website experiment trial-20 (Remy, 2026-10-30), the same
  // creatine -> protein bag at 20% under its own native code. Every code-aware path below
  // (stale opposite codes, restore, shipping companion, verification) reads this table.
  var OFFERS = { cm_trial_10_v1: { source: '7962437976163', variant: '44000330711139', code: 'BUNDLE-71434708' }, wp_trial_10_v1: { source: '7962437910627', variant: '44000333234275', code: 'BUNDLE-17078578' }, wp_trial_20_v1: { source: '7962437910627', variant: '44000333234275', code: 'BUNDLE-44160331' } };
  function props(line) { return line.properties || {}; }
  function codes(cart) {
    var result = (cart.discount_codes || []).map(function (d) { return d.code; });
    var allocations = (cart.cart_level_discount_applications || []).concat.apply(cart.cart_level_discount_applications || [], (cart.items || []).map(function (i) { return (i.line_level_discount_allocations || []).map(function (a) { return a.discount_application; }); }));
    allocations.forEach(function (d) { if (d && d.type === 'discount_code' && d.title) result.push(d.title); });
    return Array.from(new Set(result.filter(Boolean).map(function (s) { return s.toUpperCase(); })));
  }
  function parentPresent(cart, source) {
    return cart.items.some(function (i) { return String(i.product_id) === String(source) && i.quantity > 0 && !props(i)._anti_trial_offer; });
  }
  function trialLine(cart, config, attempt) {
    var lines = cart.items.filter(function (i) { return props(i)._anti_trial_attempt === attempt; });
    if (lines.length !== 1 || !parentPresent(cart, config.source)) return null;
    var line = lines[0];
    if (String(line.variant_id || line.id) !== config.variant || line.quantity !== 1 || line.selling_plan_allocation || props(line)._anti_trial_offer !== config.offer) return null;
    var savings = (line.line_level_discount_allocations || []).reduce(function (sum, a) {
      var d = a.discount_application || {};
      return sum + (d.type === 'discount_code' && String(d.title).toUpperCase() === config.code.toUpperCase() ? Number(a.amount) : 0);
    }, 0);
    // Liquid's price is a snapshot; fail closed if pricing changed since render.
    return savings === config.retail - config.price && savings > 0 && Number(line.original_price) === config.retail && Number(line.final_line_price) === config.price ? line : null;
  }
  // Shipping follows a real native bundle allocation, not a marker alone.
  // Split discounted/full-price quantity rows are valid; only one bag needs
  // the native 10% allocation. Upgrading or removing that bag revokes shipping.
  function isRoute(line) { return String(line.vendor || '').toLowerCase() === 'route'; }
  // Discounted merchandise, excluding Route, from line and allocation facts.
  // Never read cart.total_price here. Once the cart knows a delivery address
  // (a ZIP typed at checkout, then Back), Shopify's update.js/change.js
  // responses add the default delivery rate to total_price: a $96.50 mixed
  // bundle answered 14168, FedEx 2Day included (2026-10-09 review). GET
  // /cart.js and Liquid stay correct. Matches the drawer's Liquid figure.
  function merchandiseCents(cart) {
    var lines = (cart.items || []).filter(function (line) { return !isRoute(line); });
    if (!lines.length || !lines.every(function (line) { return Number.isFinite(line.final_line_price); })) return NaN;
    var subtotal = lines.reduce(function (sum, line) { return sum + line.final_line_price; }, 0);
    // Order-level discounts are not in final_line_price. Shopify wraps each
    // as { amount, discount_application }; accept the bare application too.
    return (cart.cart_level_discount_applications || []).reduce(function (sum, entry) {
      var d = entry && entry.discount_application || entry || {};
      var amount = Number(entry && entry.amount != null ? entry.amount : d.total_allocated_amount);
      return d.target_type === 'shipping_line' || !Number.isFinite(amount) ? sum : sum - amount;
    }, subtotal);
  }
  function shippingAlreadyFree(cart, offer) {
    // Standard shipping is already free at $100 after discounts. Sending a
    // redundant shipping code can surface an invalid-code error in checkout.
    // Route is not merchandise and cannot unlock this threshold. Keep the
    // companion for a mixed subscription/one-time cart below the threshold:
    // its one-time portion can still have a paid standard shipping rate.
    // Unknown merchandise keeps the companion: omitting it is the only
    // direction that can charge a shopper the drawer promised free shipping.
    var subtotal = merchandiseCents(cart);
    if (cart.currency !== 'USD' || !Number.isFinite(subtotal)) return false;
    if (offer) {
      // Acceptance may hold the confirmed parent-only snapshot or a fresh
      // cart with the added bag. Project the one-unit native trial price so
      // the combined update never adds a shipping code it already doesn't need.
      var added = (cart.items || []).find(function (line) { return !isRoute(line) && props(line)._anti_trial_offer === offer.offer && String(line.variant_id || line.id) === offer.variant; });
      subtotal += offer.price - (added ? added.final_line_price : 0);
    }
    return subtotal >= 10000;
  }
  function shippingEligible(cart) {
    if (shippingAlreadyFree(cart)) return false;
    return (cart.items || []).some(function (line) {
      var offer = OFFERS[props(line)._anti_trial_offer];
      return offer && !line.selling_plan_allocation && line.quantity > 0 &&
        String(line.variant_id || line.id) === offer.variant && parentPresent(cart, offer.source) &&
        (line.line_level_discount_allocations || []).some(function (a) {
          var d = a.discount_application || {};
          return a.amount > 0 && d.type === 'discount_code' && String(d.title).toUpperCase() === offer.code;
        });
    });
  }
  // Match the drawer: USD merchandise after discounts, excluding Route.
  // A subscription or an existing shipping offer already unlocked shipping.
  function unlocksShipping(cart, price, alreadyClaimed) {
    if (alreadyClaimed || cart.currency !== 'USD' || !(price > 0)) return false;
    if (cart.items.some(function (i) { return !!i.selling_plan_allocation; })) return false;
    var applications = (cart.cart_level_discount_applications || []).concat.apply(cart.cart_level_discount_applications || [], cart.items.map(function (i) {
      return (i.line_level_discount_allocations || []).map(function (a) { return a.discount_application || {}; });
    }));
    if (applications.some(function (a) { return a.target_type === 'shipping_line'; })) return false;
    var subtotal = merchandiseCents(cart);
    return Number.isFinite(subtotal) && subtotal < 10000 && subtotal + price >= 10000;
  }
  function create(env) {
    var busy = false;
    function request(path, body, form) {
      var options = { credentials: 'same-origin', headers: { Accept: 'application/json' } };
      if (body) {
        options.method = 'POST';
        options.headers['Content-Type'] = form ? 'application/x-www-form-urlencoded;charset=UTF-8' : 'application/json';
        options.body = form ? body.toString() : JSON.stringify(body);
      }
      return env.fetch(env.root + path, options).then(function (r) {
        var shared = env.cartState && env.cartState();
        var revision = shared && shared.revisionOf(r);
        return r.json().then(function (data) {
          if (typeof revision === 'number') Object.defineProperty(data, '__antiCartRevision', { value: revision });
          if (!r.ok || data.status >= 400) { var error = new Error(data.description || 'The cart could not be updated. Please try again.'); error.definite = [400, 404, 409, 422].indexOf(Number(r.status || data.status)) >= 0; throw error; }
          if (shared && shared.confirm) shared.confirm(data, revision);
          return data;
        });
      });
    }
    function read() {
      var shared = env.cartState && env.cartState();
      if (!shared || typeof shared.readFresh !== 'function') return request('cart.js');
      // Route may still be settling its metadata when an offer is accepted.
      // Wait for observed writes rather than failing a normal fast click.
      return bounded(shared.whenIdle ? shared.whenIdle() : Promise.resolve()).then(function () { return shared.readFresh(); });
    }
    function bounded(work) {
      return new Promise(function (resolve, reject) {
        var timer = (env.setTimeout || setTimeout)(function () {
          // An unfinished write may still commit. Leave the persisted attempt;
          // only an explicit retry with a fresh, settled cart may reconcile it.
          reject(new Error('The add could not be confirmed. Retry to check the cart without adding another bag.'));
        }, 10000);
        Promise.resolve(work).then(function (result) {
          (env.clearTimeout || clearTimeout)(timer);
          resolve(result);
        }, function (error) {
          (env.clearTimeout || clearTimeout)(timer);
          reject(error);
        });
      });
    }
    function settleWrite(work) {
      return bounded(Promise.resolve().then(work).then(function (value) {
        return { status: 'fulfilled', value: value };
      }, function (reason) { return { status: 'rejected', reason: reason }; }));
    }
    function stable(value) {
      if (Array.isArray(value)) return '[' + value.map(stable).join(',') + ']';
      if (value && typeof value === 'object') return '{' + Object.keys(value).sort().map(function (key) { return JSON.stringify(key) + ':' + stable(value[key]); }).join(',') + '}';
      return JSON.stringify(value);
    }
    function completeCart(cart) {
      return !!cart && !cart.errors && !(cart.status >= 400) && typeof cart.token === 'string' && !!cart.token &&
        Number.isInteger(cart.item_count) && cart.item_count >= 0 && Number.isFinite(cart.total_price) &&
        typeof cart.currency === 'string' && !!cart.currency && Array.isArray(cart.items) && cart.items.every(function (line) {
          return line && typeof line === 'object' && !Array.isArray(line) && Number.isInteger(line.quantity) && line.quantity > 0 &&
            typeof line.key === 'string' && !!line.key && Number.isFinite(line.final_line_price);
        }) && cart.items.reduce(function (sum, line) { return sum + line.quantity; }, 0) === cart.item_count;
    }
    function priorLines(cart, attempt) {
      return cart.items.filter(function (line) { return props(line)._anti_trial_attempt !== attempt; }).map(function (line) {
        // Discount allocation can change Shopify's line key. Preserve the
        // merchandise, quantity, customizations, selected plan and its prices.
        var plan = line.selling_plan_allocation;
        var terms = plan ? [plan.selling_plan && plan.selling_plan.id, plan.price, plan.compare_at_price, plan.per_delivery_price] : null;
        return stable([String(line.variant_id || line.id), String(line.product_id), line.quantity, props(line), terms, line.original_price, line.final_line_price, line.vendor || '']);
      }).sort();
    }
    function sectionsMatch(cart) {
      if (!cart.sections || typeof cart.sections['cart-drawer'] !== 'string') return false;
      var Parser = env.DOMParser || (typeof DOMParser !== 'undefined' && DOMParser);
      if (!Parser) return false;
      try {
        var doc = new Parser().parseFromString(cart.sections['cart-drawer'], 'text/html');
        var lines = cart.items.filter(function (line) { return line.vendor !== 'Route'; });
        var inputs = Array.from(doc.querySelectorAll('input[name^="updates["]'));
        if (inputs.length !== lines.length || lines.some(function (line) {
          var matching = inputs.filter(function (input) { return input.getAttribute('name') === 'updates[' + line.key + ']'; });
          return matching.length !== 1 || Number(matching[0].getAttribute('value')) !== line.quantity;
        })) return false;
        var receipt = doc.querySelector('[data-cc-receipt]');
        var merchandise = merchandiseCents(cart);
        return !!receipt && receipt.getAttribute('data-merch-cents') !== null && Number(receipt.getAttribute('data-merch-cents')) === merchandise && receipt.getAttribute('data-currency') === cart.currency;
      } catch (_) { return false; }
    }
    function confirmedWriteCart(shared, before, startRevision, outcomes, config, record) {
      if (typeof startRevision !== 'number' || outcomes.some(function (outcome) { return outcome.status !== 'fulfilled'; })) return null;
      var cart = outcomes[1].value, revision = shared.revision();
      if (revision !== startRevision + 2 || !completeCart(cart) || cart.token !== before.token || cart.currency !== before.currency ||
          !trialLine(cart, config, record.attempt) || before.items.some(function (line) { return props(line)._anti_trial_attempt === record.attempt; }) ||
          stable(priorLines(cart, record.attempt)) !== stable(priorLines(before, record.attempt)) ||
          stable(cart.attributes) !== stable(before.attributes) || stable(cart.note) !== stable(before.note) ||
          stable(codes(cart).sort()) !== stable(offerCodes(before, config, record).sort())) return null;
      var line = trialLine(cart, config, record.attempt);
      if (props(line)._anti_trial_source !== 'pdp_cross_sell' || props(line)._anti_trial_code !== config.code ||
          (typeof cart.__antiCartRevision === 'number' && cart.__antiCartRevision !== revision)) return null;
      // Add has settled before Update starts. The complete update must also
      // contain the brand-new attempt before its cart/sections can be reused.
      // No other observed write may intervene, and the service must confirm it.
      // Check HTML independently: a valid cart alone never proves its sections.
      if (!sectionsMatch(cart)) delete cart.sections;
      if (!shared.confirm(cart, revision)) return null;
      if (typeof cart.__antiCartRevision !== 'number') Object.defineProperty(cart, '__antiCartRevision', { value: revision });
      return cart;
    }
    function staleOfferCodes(cart, config) {
      // Shopify retains inapplicable codes after a shopper empties/rebuilds a
      // cart. The opposite BXGY can then win when this new bag is added.
      // Identify only our inactive opposite offer BEFORE Add; never discard a
      // shopper's other promotion or an already allocated saving.
      return Object.keys(OFFERS).map(function (key) { return OFFERS[key].code; }).filter(function (code) {
        return code !== config.code.toUpperCase() && (cart.discount_codes || []).some(function (d) {
          return String(d.code).toUpperCase() === code && d.applicable === false;
        }) && !(cart.items || []).some(function (line) {
          return (line.line_level_discount_allocations || []).some(function (a) {
            return a.amount > 0 && String((a.discount_application || {}).title).toUpperCase() === code;
          });
        });
      });
    }
    function offerCodes(cart, config, record) {
      var stale = record && record.staleOfferCodes || [];
      var active = codes(cart).filter(function (code) { return code !== SHIPPING_CODE && stale.indexOf(code) < 0 && (!config.legacyCode || code !== config.legacyCode.toUpperCase()); });
      if (active.indexOf(config.code.toUpperCase()) < 0) active.push(config.code.toUpperCase());
      if (!shippingAlreadyFree(cart, config)) active.push(SHIPPING_CODE);
      return active;
    }
    function applyOffer(cart, config, sections, record) {
      var update = { discount: offerCodes(cart, config, record).join(',') };
      if (sections) {
        update.sections = sections;
        update.sections_url = typeof location !== 'undefined' ? location.pathname : '/cart';
      }
      return request('cart/update.js', update);
    }
    async function syncShipping(cart, sections) {
      if (!cart || !cart.items || cart.errors) return cart;
      var active = codes(cart), present = active.indexOf(SHIPPING_CODE) >= 0;
      var eligible = shippingEligible(cart);
      if (present === eligible) return cart;
      var keep = active.filter(function (code) { return code !== SHIPPING_CODE; });
      if (eligible) keep.push(SHIPPING_CODE);
      var body = { discount: keep.join(',') };
      if (sections) { body.sections = sections; body.sections_url = typeof location !== 'undefined' ? location.pathname : '/cart'; }
      var updated = await request('cart/update.js', body);
      if ((codes(updated).indexOf(SHIPPING_CODE) >= 0) !== eligible) throw new Error('Shipping could not be updated. Please try again.');
      return updated;
    }
    function save(key, record) { env.storage.setItem(key, JSON.stringify(record)); }
    function clear(key) { env.storage.removeItem(key); }
    function configFor(screen, source) {
      return { source: source, target: screen.getAttribute('data-xs-product'), variant: screen.getAttribute('data-xs-variant'), offer: screen.getAttribute('data-xs-offer'), code: screen.getAttribute('data-trial-code') || '', legacyCode: screen.getAttribute('data-trial-legacy-code') || '', retail: Number(screen.getAttribute('data-xs-retail')), price: Number(screen.getAttribute('data-xs-price')) };
    }
    function removeAttempt(cart, config, record) {
      // Re-read after each removal: discount changes can replace line keys.
      var matching = cart.items.find(function (i) { return props(i)._anti_trial_attempt === record.attempt; });
      if (!matching) return Promise.resolve(cart);
      return request('cart/change.js', { id: matching.key, quantity: 0 }).then(function () { return read(); }).then(function (next) { return removeAttempt(next, config, record); });
    }
    function restoreCodes(cart, config, record) {
      var keep = codes(cart).filter(function (code) { return code !== config.code.toUpperCase() && code !== SHIPPING_CODE; });
      // A code present before this attempt is never removed.
      record.priorCodes.forEach(function (c) { if (keep.indexOf(c) < 0) keep.push(c); });
      return request('cart/update.js', { discount: keep.join(',') }).then(function (updated) {
        var restored = codes(updated);
        if (restored.length !== keep.length || keep.some(function (code) { return restored.indexOf(code) < 0; })) {
          throw new Error('Please review your cart: the trial could not be confirmed or removed.');
        }
        return updated;
      });
    }
    function rollback(config, record, key) {
      return read().then(function (cart) { return removeAttempt(cart, config, record); }).then(function (cart) {
        return restoreCodes(cart, config, record);
      }).then(function () { clear(key); });
    }
    async function run(screen, source, sections, fresh) {
      var config = configFor(screen, source);
      if (!config.code) throw new Error('This offer is unavailable. Please continue with your cart.');
      if (!/^[A-Z0-9-]+$/i.test(config.code) || !(config.price > 0 && config.price < config.retail)) throw new Error('This offer is unavailable. Please continue with your cart.');
      var shared = env.cartState && env.cartState();
      var cached = shared && shared.peek();
      var cart = (!fresh && cached) || await read();
      var key = 'anti-trial:' + cart.token + ':' + config.offer;
      var record;
      try { record = JSON.parse(env.storage.getItem(key) || 'null'); } catch (_) { throw new Error('Please review your cart before trying this offer again.'); }
      // A persisted attempt means a write may have committed without a response.
      // Reconcile on the server even when an otherwise fresh snapshot exists.
      if (cached && record) {
        cart = await read();
        key = 'anti-trial:' + cart.token + ':' + config.offer;
        try { record = JSON.parse(env.storage.getItem(key) || 'null'); } catch (_) { throw new Error('Please review your cart before trying this offer again.'); }
      }
      if (record && record.code !== config.code) throw new Error('This test offer has changed. Please review your cart before retrying.');
      var newlyAdded = false, reconciled = false, addFailure = null;
      if (!record) {
        if (!parentPresent(cart, source)) throw new Error('Keep the original product in your cart to use this offer.');
        if (cart.items.some(function (i) { return String(i.product_id) === config.target || props(i)._anti_trial_offer; })) throw new Error('This item is already in your cart.');
        record = { attempt: env.uuid(), priorCodes: codes(cart), staleOfferCodes: staleOfferCodes(cart, config), code: config.code, stage: 'adding', at: (env.now || Date.now)() };
        // Persist before the request. A lost add response cannot trigger a second add.
        save(key, record);
        var form = new URLSearchParams({ id: config.variant, quantity: '1' });
        form.set('properties[_anti_trial_offer]', config.offer);
        form.set('properties[_anti_trial_source]', 'pdp_cross_sell');
        form.set('properties[_anti_trial_attempt]', record.attempt);
        form.set('properties[_anti_trial_code]', config.code);
        if (shared && typeof shared.readFresh === 'function' && typeof cart.token === 'string' && cart.token) {
          // Do not overlap Add and discount Update. Real Shopify responses
          // acknowledged Add with the trial, then a concurrent discount Update
          // overwrote it with a parent-only cart (2026-10-07 checkout audit).
          // Keep the confirmed snapshot, bundled sections and fresh-read recovery;
          // only the two writes must run in order.
          reconciled = true;
          var token = cart.token;
          var startRevision = shared.revision && shared.isCurrent && shared.confirm && completeCart(cart) && shared.peek() === cart && shared.isCurrent(shared.revision()) ? shared.revision() : null;
          var outcomes = [await settleWrite(function () { return request('cart/add.js', form, true); }), { status: 'skipped' }];
          addFailure = outcomes[0].status === 'rejected' ? outcomes[0].reason : null;
          // No discount request exists yet, so a definite rejected Add needs
          // no code cleanup. Unknown outcomes still reconcile without re-adding.
          if (addFailure && addFailure.definite) { clear(key); throw addFailure; }
          if (!addFailure) {
            record.stage = 'applying'; save(key, record);
            outcomes[1] = await settleWrite(function () { return applyOffer(cart, config, sections, record); });
          } else reconciled = false; // Recovery still owes the combined code update.
          // A failed read leaves the persisted attempt for a later fresh retry.
          // Never resend Add merely because either response was lost.
          var confirmed = null;
          try { confirmed = confirmedWriteCart(shared, cart, startRevision, outcomes, config, record); }
          catch (_) { /* Malformed optional fields cannot bypass fresh verification. */ }
          cart = confirmed || await read();
          if (cart.token !== token) throw new Error('Please review your cart before trying this offer again.');
        } else {
          // Older adapters without fresh-read/pending-write guards stay serial.
          try { await request('cart/add.js', form, true); newlyAdded = true; }
          catch (error) {
            if (error.definite) { clear(key); throw error; }
            throw new Error('The add could not be confirmed. Retry to check the cart without adding another bag.');
          }
        }
      }
      // Retries reconcile before writing. Current acceptance also checks its
      // fresh read, including when Add committed but its response was lost.
      var attempted = cart.items.filter(function (i) { return props(i)._anti_trial_attempt === record.attempt; });
      if (!newlyAdded && !attempted.length) {
        // Records from before the timestamp keep the old, conservative behavior.
        var expired = !fresh && typeof record.at === 'number' && (env.now || Date.now)() - record.at > RECOVERY_MS;
        if (record.parallel || record.stage === 'applying') {
          // Preserve recovery for persisted attempts from the old parallel
          // implementation, and any later missing bag after a discount write.
          // Retain uncertain attempts so retry cannot add a duplicate bag.
          try { await restoreCodes(cart, config, record); }
          catch (_) { throw new Error('Please review your cart: the trial could not be confirmed or removed.'); }
          if (record.addFailed) clear(key);
          if (addFailure && addFailure.definite) throw addFailure;
        }
        // Expired and still absent: start over as a new attempt from a fresh read.
        if (expired) { clear(key); return run(screen, source, sections, true); }
        throw new Error('No added bag was confirmed. Please review your cart before retrying.');
      }
      try {
        if (!parentPresent(cart, source)) throw new Error('The original product is no longer in your cart.');
        // A rejected discount write can be repaired once after the added bag
        // is confirmed. Existing persisted attempts keep the serial path.
        if (!reconciled || !trialLine(cart, config, record.attempt)) {
          record.stage = 'applying'; save(key, record);
          cart = await applyOffer(cart, config, sections, record);
        }
        var line = trialLine(cart, config, record.attempt);
        if (!line) throw new Error('The ' + Math.round((1 - config.price / config.retail) * 100) + '% offer could not be applied. Your existing promotions have been kept.');
        cart = await syncShipping(cart, sections);
        line = trialLine(cart, config, record.attempt);
        if (!line) throw new Error('The offer could not be confirmed. Please try again.');
        clear(key);
        return { cart: cart, line: line };
      } catch (error) {
        try { await rollback(config, record, key); }
        catch (_) { throw new Error('Please review your cart: the trial could not be confirmed or removed.'); }
        throw error;
      }
    }
    function accept(screen, source, sections) {
      if (busy) return Promise.reject(new Error('Please wait for the current offer.'));
      busy = true;
      var task = function () { return run(screen, source, sections); };
      var result = typeof navigator !== 'undefined' && navigator.locks ? navigator.locks.request('anti-trial-cart', task) : task();
      return result.finally(function () { busy = false; });
    }
    function paintShipping(screen) {
      var button = screen.querySelector('[data-trial-cta]');
      // The selected price-first CTA is static in every shipping state. Keep
      // legacy copy support without replacing its nested price markup.
      if (!button || !button.getAttribute('data-trial-default-cta')) return Promise.resolve();
      button.textContent = button.getAttribute('data-trial-default-cta');
      return read().then(function (cart) {
        var claimed = false;
        try { claimed = !!env.shippingClaimed && env.shippingClaimed(); } catch (_) { /* Default to cart evidence. */ }
        if (unlocksShipping(cart, Number(screen.getAttribute('data-xs-price')), claimed)) button.textContent = 'Save 10% and unlock free shipping';
      }).catch(function () { /* Keep the saving-only CTA when shipping is unverified. */ });
    }
    return { accept: accept, paintShipping: paintShipping, syncShipping: syncShipping, read: read };
  }
  return { shippingEligible: shippingEligible, SHIPPING_CODE: SHIPPING_CODE, create: create, codes: codes, trialLine: trialLine, unlocksShipping: unlocksShipping };
});
